import React from 'react'

function ProfileInsurance() {
    return (
        <>
            <form>
                <div className=''>
                    <div className=' load-input-wrapper'>
                        <div className=' load-input'>
                            <label>Name</label>
                            <input required type={'text'} placeholder="Khalid Transportation LLC" className='form-input_ input' />
                        </div>
                        <div className=' load-input'>
                            <label >Policy Number</label>
                            <input required type={'text'} placeholder="MCP23479123129736" className='form-input_ input' />
                        </div>
                        <div className=' load-input'>
                            <label>Phone </label>
                            <input required type={'text'} placeholder="80808080" className='form-input_ input' />
                        </div>
                        <div className=' load-input'>
                            <label>Start Date</label>
                            <input required type={'date'} className='form-input_ input1' />
                        </div>
                        <div className=' load-input'>
                            <label>End date</label>
                            <input required type={'date'} className='form-input_ input1' />
                        </div>
                        <div className=' load-input'>
                            <label>Address</label>
                            <input required type={'text'} placeholder={"123 Madison St STE 200"} className='form-input_ select1' />
                        </div>
                        <div className=' load-input'>
                            <label>.</label>
                            <select required name="" className='form-input_ select1'>
                                <option value="">Select</option>
                                <option value="" selected>Chicago</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label>.</label>
                            <select required name="" className='form-input_ select1'>
                                <option value="">Select</option>
                                <option value="" selected>IL</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label>.</label>
                            <input required type={'number'} placeholder={"1234"} className='form-input_ select1' />
                        </div>
                    </div>
                    <div className='form-buttons'>
                        <button className='button-primary'>Save Changes</button>
                        <button className='button-primary btn-cancel'>Cancel</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default ProfileInsurance